<template>
  <component :is="tag" :class="classList" v-bind="attributes">
    <span><slot /></span>
    <svg
      :class="'icon icon--' + icon.replace('icon-', '') + ''"
      :width="iconSize"
      :height="iconSize"
      v-if="icon !== false"
    >
      <use :xlink:href="'#' + icon" />
    </svg>
  </component>
</template>
<script>
export default {
  name: "UiButton",
  props: {
    size: {
      type: String,
      default: null
    },
    theme: {
      type: String,
      default: "primary"
    },
    variant: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: "icon-arrow-right"
    },
    href: {
      type: String,
      default: null
    },
    to: {
      type: [String, Object],
      default: null
    }
  },
  computed: {
    tag() {
      if (this.href) {
        return "a";
      }
      if (this.to) {
        return "router-link";
      }
      return "button";
    },
    attributes() {
      if (this.tag === "a") {
        return {
          href: this.href,
          target: "_blank"
        };
      }
      if (this.tag === "router-link") {
        return {
          to: this.to
        };
      }
      return {
        type: "button"
      };
    },
    classList() {
      return {
        btn: true,
        [`btn--${this.theme}`]: this.theme,
        [`btn--${this.variant}`]: this.variant,
        [`btn--${this.size}`]: this.size
      };
    },
    iconSize() {
      return this.size === "small" ? 18 : 24;
    }
  }
};
</script>
